import _ from "lodash";
import { isValidObject } from "app/main/apps/common/AuraFunctions";
import { vasDefaultTypesAndIncludes } from "./VasConfig";
import { openVasDialog } from "../../store/orderSlice";

/**
 *  Vas Table Header for add/edit
 */
export const vasPriceListHeader = [
  { name: "Type" },
  { name: "Category" },
  { name: "Service" },
  { name: "Unit Type" },
  { name: "FOB ($)" },
  { name: "Qty/Sq.ft" },
  { name: "Margin (%)" },
  { name: "Discount (%)" },
  { name: "Amount" },
  { name: "" },
];

/**
 *  Vas Table Header for view
 */
export const vasPriceListHeaderCustomerView = [
  { name: "Type" },
  { name: "Category" },
  { name: "Service" },
  { name: "Unit Type" },
  { name: "Qty/Sq.ft" },
  { name: "Unit Price" },
  { name: "Discount" },
  { name: "Total Amount" },
];
/**
 *  Vas Table Header for view
 */
export const vasPriceListHeaderView = [
  { name: "Type" },
  { name: "Category" },
  { name: "Service" },
  { name: "Unit Type" },
  { name: "FOB" },
  { name: "Qty/Sq.ft" },
  { name: "Discount" },
  { name: "Total Amount" },
];

/**
 *  Base Vas Table Header
 */
export const vasPriceListHeaderBase = [
  { name: "Type" },
  { name: "Category" },
  { name: "Service" },
  { name: "Unit Type" },
  { name: "FOB" },
  { name: "Qty/Sq.ft" },
];

/**
 *  Vas Table Products list Header
 */
export const vasProductHeader = [
  { name: "No" },
  { name: "Name" },
  { name: "Sub Type" },
  { name: "Reference" },
  { name: "Decedents" },
  { name: "Qty" },
];

/**
 *  Handles to get table header array based on type param
 */
export function getVasPriceListHeader(type, isCustomerUser) {
  if (type === "base") {
    return vasPriceListHeaderBase;
  }
  if (type === "view" && isCustomerUser === true) {
    return vasPriceListHeaderCustomerView;
  }
  if (type === "view") {
    return vasPriceListHeaderView;
  }
  return vasPriceListHeader;
}

/**
 * This method set the product type or includes values to true, if it present in order details
 */
export default function getDefaultProductTypes(orderDetails) {
  const updatedData = _.cloneDeep(vasDefaultTypesAndIncludes);

  orderDetails.forEach((item) => {
    let productName = item.product.type.name;

    // Take first Part. Added condition since we have pick only Die from Die/Tablet
    if (productName.includes("/")) {
      productName = productName.split("/")[0].trim();
    }

    // Check and update types
    if (_.has(updatedData.types, productName)) {
      updatedData.types[productName] = true;
    }

    // Check and update includes
    if (_.has(updatedData.includes, productName)) {
      updatedData.includes[productName] = true;
    }
  });
  return updatedData;
}

/**
 * This method will keep only id from the documents array
 */
export const getJsonVas = (vasParam) => {
  let vasJson;
  if (vasParam && isValidObject(vasParam)) {
    const vasTemp = _.cloneDeep(vasParam);
    const transformedVas = transformDocuments(vasTemp);
    vasJson = JSON.stringify(transformedVas);
  }
  return vasJson;
};

/**
 * This method will keep only id from the documents array
 */
export const transformDocuments = (inputObject) => {
  if (inputObject && typeof inputObject === "object") {
    Object.entries(inputObject).forEach(([key, value]) => {
      if (key && key === "documents" && Array.isArray(value)) {
        inputObject[key] = value.map((item) => {
          if (item.id !== undefined) {
            return { id: item.id }; // Keep only 'id'.
          }
          return item;
        });
      } else if (typeof value === "object" && value !== null) {
        // Recursively process nested objects.
        transformDocuments(value);
      }
    });
  }
  return inputObject;
};

/**
 * Handles to get unique categories in ascending order from input param
 */
export const getUniqueCategories = (data) => {
  if (data && data?.length > 0)
    return _.sortBy(_.uniq(data?.map((item) => item?.category)));
  return [];
};

/**
 * Handles to get unique service based on category in ascending order
 */
export const getRecordsByCategory = (data, category) => {
  if (data && data?.length > 0) {
    const filteredRecords = _.filter(data, { category });
    return _.sortBy(_.uniqBy(filteredRecords, "name"));
  }
  return [];
};

/**
 * Handles to get unique records based on given category and service
 */
export const getUnitPriceRecord = (data, category, service) => {
  if (data && data?.length > 0) {
    const filteredRecords = _.filter(data, { category, name: service });
    // Combine 'category' and 'name' for uniqueness
    return _.uniqBy(
      filteredRecords,
      (record) => `${record.category}-${record.name}`
    );
  }
  return [];
};

/**
 * Handles to open Vas Preview dialog
 */
export const openVasPreview = (dispatch, vasData, orderData = null) => {
  dispatch(
    openVasDialog({
      data: vasData,
      completeOrderData: orderData,
      param: {
        dialogParam: {
          type: "View",
          name: "view",
          title: "Sandblating/Etching Services (VAS)",
          hideDialogActions: true,
          maxWidth: "md",
          style: {
            contentSxStyle: {
              padding: "20px !important",
              height: "90vh !important",
            },
          },
        },
      },
      field: "vasPreviewDialog",
    })
  );
};

/**
 * Handles to show or hide Vas Price details
 */
export const canPageHaveVasPriceDetails = (stage, paramType, vas) => {
  return (
    stage === "quote" ||
    stage === "order" ||
    (stage === "rfq" && paramType === "convert-to-quote")
  );
};

/**
 * Handles to show or hide Vas Price details
 */
export const showVasPriceDetails = (stage, paramType, vas) => {
  return (
    (stage === "quote" ||
      stage === "order" ||
      (stage === "rfq" && paramType === "convert-to-quote")) &&
    isValidObject(vas)
  );
};

/**
 * Handles to check whether Vas Price details included if VAS present
 */
export const hasInValidVASPriceDetails = (inputData, vas) => {
  if (
    isValidObject(vas) &&
    (!inputData.vas_price_details ||
      (inputData.vas_price_details && inputData.vas_price_details.length <= 0))
  ) {
    return true;
  }
  return false;
};
